import { ReportComponent } from '@/types';
import { ReportComponentConfig } from '@/types/api/modules/business-intelligence';

import { apiClient } from '../http';
import { toReportComponentCreateInput, toReportComponentUpdateInput } from './resourceMutationPayloads';
import { createSanitizedResourceService, QueryParams } from './resources';

export type ReportComponentLayoutPatch = Pick<ReportComponent, 'id' | 'tileX' | 'tileY' | 'tileWidth' | 'tileHeight'>;

const base = createSanitizedResourceService<
    ReportComponent,
    ReturnType<typeof toReportComponentCreateInput>,
    ReturnType<typeof toReportComponentUpdateInput>
>('/api/report-components', toReportComponentCreateInput, toReportComponentUpdateInput);

export const reportComponentService = {
    ...base,
    getPublicById: (id: string) =>
        apiClient.get<ReportComponent>(`/public/report-components/${id}`, { mode: 'unauthorized' }),
    getPublicMemoComponent: (memoId: string, reportComponentId: string) =>
        apiClient.get<ReportComponent>(`/public/memos/${memoId}/report-components/${reportComponentId}`, {
            mode: 'unauthorized',
        }),
    list: <TParams extends QueryParams = QueryParams>(params?: TParams) => base.list(params),
    listByReport: (reportId: string) => apiClient.get<ReportComponent[]>(`/api/reports/${reportId}/components`),
    setArchived: (id: string, archived: boolean) => base.update(id, { archived }),
    setFavorite: (id: string, favorited: boolean) => base.update(id, { favorited }),
    setLocked: (id: string, locked: boolean) => base.update(id, { locked }),
    updateConfiguration: (id: string, configuration: ReportComponentConfig) =>
        apiClient.patch<ReportComponent, { configuration: ReportComponentConfig }>(
            `/api/report-components/${id}/configuration`,
            { configuration },
        ),
    updateLayout: (reportId: string, components: ReportComponentLayoutPatch[]) =>
        apiClient.put<void, { components: ReportComponentLayoutPatch[] }>(
            `/api/reports/${reportId}/components/layout`,
            {
                components,
            },
        ),
};
